import React, { FC } from 'react';
import { Homepage } from '@pages/Homepage';

import phoneMapping from "@phone-numbers/generic-phone-numbers";
import pageData from './data.json';
import {LeadgenPopupType} from "@components/LeadgenPopupFlow";

const html = require('./legacy.html');

type Props = {
  pathname: string;
  mode: string;
}

export const HomepageDisability: FC<Props> = (props) => {
  return (
    <Homepage
      pathname={props.pathname}
      pagename='disability'
      mode={props.mode}
      pageData={pageData}
      leadgenPopupType={LeadgenPopupType.DISABILITY}
      phoneMapping={phoneMapping}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Homepage>
  )
}
